/**
 * As LISTAS do imóvel — as sugestões que o Richard mandou em 12/09/2026.
 *
 * > *"Acrescentar tag de tipo de documento com as opções de: Acordo
 * > Extrajudicial, Aditamento, Adjudicação…"* · *"um campo com tipos para a
 * > classificação (outorgante, outorgado, devedor…)"* · *"TIPO DO IMÓVEL
 * > (incluir as opções de vaga de garagem, box, sala comercial…)"*
 *
 * ⚠️ **São SUGESTÕES, e a escrita continua livre** (§39.1, decisão 4: *"a lista
 * exatamente como veio, e escrita livre para o que faltar"*). Por isso moram
 * num `datalist`, e não num `select`: a matrícula traz título que nenhuma lista
 * fecha.
 *
 * ⚠️ **Na ordem em que vieram.** A única mudança: "Mútuo" veio duas vezes, e
 * uma lista de sugestões não repete opção.
 */

/** Escritura/título — o tipo do ato (§39.1, decisão 4). */
export const TIPOS_DE_ATO = [
  'Acordo Extrajudicial',
  'Aditamento',
  'Adjudicação',
  'Adoção',
  'Alienação Fiduciária',
  'Arrendamento Mercantil (Leasing)',
  'Ata Notarial',
  'Bem de Família',
  'Cessão de Direitos Aquisitivos',
  'Cessão de Direitos de Crédito',
  'Cessão de Direitos Hereditário',
  'Mútuo',
  'Cessão de Direitos Possessórios',
  'Garantia Fiduciária',
  'Compra e Venda',
  'Compra e Venda com Alienação Fiduciária',
  'Compromisso de Compra e Venda',
  'Concessão de Domínio',
  'Condomínio',
  'Conferência de Bens',
  'Confissão de Dívida',
  'Dação em Pagamento',
  'Hipoteca',
  'Declaração',
  'Declaração de União Estável',
  'Desapropriação',
  'Desmembramento',
  'Direito de Uso de Superfície',
  'Dissolução de União Estável',
  'União Estável',
  'Casamento',
  'Certidão de Nascimento',
  'Divórcio',
  'Distrato',
  'Emancipação',
  'Doação',
  'Emissão de Cédula',
  'Escritura',
  'Fiança',
  'Incorporação',
  'Integralização de Capital',
  'Penhor',
  'Prestação de Serviços',
  'Permuta',
  'Parcelamento',
  'Promessa de Compra e Venda',
  'Renúncia',
  'Rerratificação',
  'Servidão',
  'Outros',
] as const;

/** A qualidade da parte no ato — a lista dele de 12/09. */
export const QUALIDADES_NO_ATO = [
  'Outorgante',
  'Outorgado',
  'Devedor',
  'Representante do outorgante',
  'Representante do outorgado',
  'Credor',
  'Procurador do outorgado',
  'Interveniente anuente',
  'Cedente',
  'Cessionário',
  'Requerente',
  'Usufrutuário',
  'Garantidor',
  'Garantidor hipotecário',
  'Fiduciante',
  'Fiduciário',
  'Testemunha',
  'Notificante',
  'Notificado',
  'Contratante',
  'Contratado',
  'Representante',
  'Representado',
  'Comprador',
  'Vendedor',
  'Doador',
  'Testador',
  'Transmitente',
  'Adquirente',
  'Outros',
] as const;

/**
 * A relação com a outra parte — a do prompt de escrituras que ele trouxe.
 * ⚠️ *"Preencher somente quando documentalmente identificável… Não presumir
 * parentesco apenas por sobrenome."*
 */
export const RELACOES = [
  'Familiar',
  'Societária',
  'Negocial',
  'Profissional',
  'Credor/devedor',
  'Terceiro sem vínculo identificado',
] as const;

/**
 * O tipo do imóvel — as denominações que ele listou, na ordem dele, e depois
 * as *"outras denominações que se enquadrem"* que o leitor de matrícula já
 * reconhece.
 */
export const TIPOS_DE_IMOVEL = [
  'Vaga de garagem',
  'Box',
  'Sala comercial',
  'Apartamento',
  'Imóvel rural',
  'Imóvel urbano',
  'Gleba',
  'Sítio',
  'Casa',
  'Terreno',
  'Loja',
  'Galpão',
  'Fazenda',
  'Chácara',
] as const;
